import React from 'react';

interface RimDocumentsPopupProps {
  showHistoria: boolean;
  setShowHistoria: (show: boolean) => void;
  imageSrc: string;
  imageAlt?: string;
  onContinue?: () => void;
}

export const RimDocumentsPopup: React.FC<RimDocumentsPopupProps> = ({
  showHistoria,
  setShowHistoria,
  imageSrc,
  imageAlt = 'Imagen de la historia',
  onContinue,
}) => {
  if (!showHistoria) return null;

  const handleContinue = () => {
    setShowHistoria(false);
    // localStorage.setItem('historiaModalShown', 'true');
    if (onContinue) {
      onContinue();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          position: 'relative',
          background: 'white',
          borderRadius: 12,
          boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
          padding: '16px',
          maxWidth: 400,
          width: '90vw',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Unica Imagen */}
        <img
          src={imageSrc}
          alt={imageAlt}
          style={{ width: '100%', borderRadius: 8, display: 'block' }}
        />

        {/* Botón Continuar abajo en el centro */}
        <div style={{ marginTop: 16, width: '100%', display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={handleContinue}
            style={{
              background: '#ff9800',
              color: '#ffffff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 24px',
              fontSize: 16,
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
              transition: 'background 0.2s',
            }}
            onMouseOver={(e) => {
              (e.currentTarget as HTMLButtonElement).style.background = '#e68a00';
            }}
            onMouseOut={(e) => {
              (e.currentTarget as HTMLButtonElement).style.background = '#ff9800';
            }}
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default RimDocumentsPopup;